export default __webpack_public_path__ + "static/media/851.2ce504eb.png";